/**
 * Some button variants from the CMS are not directly mappable to the button types available, this matches the previous implementation.
 * @param variant - The variant of the button from the CMS.
 * @returns The type of button to render.
 */
export function buttonVariantToType(variant) {
    switch (variant) {
        case 'primary':
            return 'primary';
        case 'secondary':
            return 'secondary';
        case 'tertiary':
            return 'tertiary';
        case 'text':
            return 'text-only';
        case 'ghost':
            return 'ghost';
        // Fall back to the default button type for these variants
        case 'secondary-2':
        case 'secondary-3':
        case 'secondary-4':
        case 'secondary-5':
        case 'tertiary-2':
        case 'tertiary-3':
        case 'tertiary-4':
        case 'tertiary-5':
        case 'tertiary-6':
            return 'text-only';
    }
}
